import React from "react";
import { useTranslation } from "react-i18next";
import { Surface } from "../../../atoms/Surface";
import { HiCreditCard } from "react-icons/hi";

interface Step4PaymentProps {
  config: {
    paymentConfig?: {
      enabled: boolean;
      paymentType?: string;
      description: string;
      amount: number;
      currency: string;
      plan_code?: string;
    };
  };
}

export const Step4Payment: React.FC<Step4PaymentProps> = ({ config }) => {
  const { t } = useTranslation();
  const { paymentConfig } = config;

  if (!paymentConfig?.enabled) {
    return null;
  }

  const formatAmount = (amountInCents: number, currency: string) => {
    const amount = amountInCents / 100;
    const currencySymbols: { [key: string]: string } = {
      USD: "$",
      EUR: "€",
      CHF: "CHF",
    };
    const symbol = currencySymbols[currency] || currency;
    return `${symbol}${amount.toFixed(2)}`;
  };

  return (
    <div className="space-y-4">
      <div className="text-center mb-4">
        <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-3">
          <HiCreditCard size={32} className="text-green-600" />
        </div>
        <h3 className="text-xl font-semibold text-gray-900 mb-2">
          {t("customRegistration.payment.stepTitle")}
        </h3>
        {paymentConfig.description && (
          <p className="text-gray-600 text-sm break-words overflow-wrap-anywhere">
            {paymentConfig.description}
          </p>
        )}
      </div>

      <Surface className="bg-gradient-to-br from-green-50 to-blue-50">
        <div className="text-center">
          {paymentConfig.paymentType === "recurring" ? (
            <p className="text-lg font-semibold text-gray-700">
              {t("customRegistration.payment.recurring")}
            </p>
          ) : (
            <p className="text-2xl font-bold text-gray-900">
              {formatAmount(paymentConfig.amount, paymentConfig.currency)}
            </p>
          )}
        </div>
      </Surface>

      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            {t("customRegistration.payment.cardNumber")}
          </label>
          <div className="relative">
            <input
              type="text"
              disabled
              placeholder="1234 5678 9012 3456"
              className="w-full p-2.5 md:p-2 text-base md:text-sm border border-gray-300 rounded-md bg-gray-50 text-gray-500"
            />
            <div className="absolute end-3 top-1/2 -translate-y-1/2">
              <HiCreditCard className="text-gray-400" size={24} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
